module.exports = __webpack_public_path__ + "img/cloud-upload-in-progress.3e9db5ce.svg";